import { ITrader, ITraderTableColumns, useTrustLevelsOptions } from '@entities/trades/trader';
import {
  FilterControlBlock,
  FilterDateRange,
  FilterInput,
  FilterSelectMulti,
} from '@features/table-filter';

import { ChangeTraderTrustLevel } from '../components/ChangeTraderTrustLevel';
import { TradersToolbar } from '../components/TradersToolbar';

interface IProps {
  refetch: () => void;
  refreshInterval?: string;
  setRefreshInterval?: (interval: string) => void;
}

export const useTableSettings = ({ refetch, refreshInterval, setRefreshInterval }: IProps) => {
  const { options: trustLevelOptions } = useTrustLevelsOptions();

  const columnTitles: ITraderTableColumns = {
    id: 'ID',
    phone: 'Phone',
    created_at: 'Registration Date',
    trust_level: 'Trust Level',
    effective_max: 'Effective Max',
  };

  const renderFilterElement = (key: keyof ITrader) => {
    switch (key) {
      case 'created_at':
        return <FilterDateRange name={key} />;

      case 'trust_level':
        return <FilterSelectMulti name='trust_level_id' options={trustLevelOptions} />;

      case 'effective_max':
        return null;

      default:
        return <FilterInput name={key as string} />;
    }
  };

  const getTheadAfter = () => (
    <th>
      <FilterControlBlock storageKey='traders'>
        <TradersToolbar
          refetch={refetch}
          refreshInterval={refreshInterval}
          setRefreshInterval={setRefreshInterval}
        />
      </FilterControlBlock>
    </th>
  );

  const renderRow = (key: keyof ITraderTableColumns, trader: ITrader) => {
    switch (key) {
      case 'trust_level':
        return <ChangeTraderTrustLevel trader={trader} refetch={refetch} />;

      case 'effective_max':
        return Math.round(Number(trader.effective_max));

      default:
        return trader[key] as string | number;
    }
  };

  const getTbodyAfter = () => <td className='action-btns-row' />;

  return {
    columnTitles,
    renderRow,
    renderFilterElement,
    getTheadAfter,
    getTbodyAfter,
  };
};
